@import './commonstyle.module.scss';
@import '../styles/mixins.scss';
@import '../styles/deviceBreakpoints';

.infoCards {
  display: flex;
  justify-content: center;
  align-items: stretch;
  width: 75%;
  margin: auto;

  @include target(md) {
    width: 65%;
    flex-direction: column;
  }

  @include target(tablet) {
    flex-direction: column;
    width: 80%;
  }

  @include target(mobile) {
    flex-direction: column;
    width: 95%;
  }

  .infoCardWrapper {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin-top: 2em;

    p {
      max-width: none;
    }

    .infoCard {
      background-color: _palette(bg-primary-light);
      border: 0.15em solid rgba(0, 0, 0, 0.5);
      border-radius: 5px;
      padding: 1em;
      margin: 0 1em;
      flex: 1 1 0;

      &:hover {
        background-color: white;
        box-shadow: 8px 8px 16px #ccc;
        cursor: pointer;

        h2 {
          color: _palette(secondary);
        }
      }

      .institutionImage {
        background: center / contain no-repeat;
        height: 10rem;
        margin-bottom: 0.4rem;
        width: 100%;
      }

      .institutionImageStudiested {
        background-image: url('img/Studiesteder.svg');
      }

      .institutionImageStudent {
        background-image: url('img/Studenter.svg');
      }

      .institutionImagePraksissted {
        background-image: url('img/Prakisissteder.svg');
      }

      h2 {
        border-bottom: 0.0625rem solid grey;
        font-size: 1.0625rem;
        font-weight: bold;
        padding-bottom: 1rem;
        text-align: center;

        &.highlighted {
          color: _palette(secondary);
        }
      }

      p.ingress {
        font-size: 1rem;
        margin: 0.625rem 0;
      }

      p:not(:last-child) {
        font-size: 0.875rem;
        margin: 0.625rem 0;
      }
    }

    .caption {
      font-size: 0.875rem;
      text-align: center;
      margin: 1em;
      flex: 0 1 auto;
      height: 5em;

      a {
        color: _palette(secondary);
        margin: 0.25rem 0;

        &:hover {
          text-decoration: none;
        }
      }
    }
  }
}

.smallPage {
  text-align: center;
}

.titleWrapper {
  text-align: left;
}

.infoPage {
  .mainContent {
    @include contentContainer;
    margin-top: 3.125rem;

    h1 {
      color: _palette(secondary);
      font-size: 1.5rem;
      margin-bottom: 1.25rem;
      text-align: left;
    }

    h3 {
      color: _palette(secondary);
      font-size: 1rem;
      margin: 0.5rem 0;
    }

    .redTitle {
      color: #c2453f;
      font-size: 1.875rem;

      @include target(mobile) {
        font-size: 1.25rem;
      }
    }

    p {
      margin-top: 0.625rem;
      text-align: left;
    }

    button {
      float: left;
    }

    ul {
      display: block;
      list-style-type: disc;
      margin: 0.5em 0;
      padding-left: 2.5rem;
    }
  }
}
